import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPrices,
} from '../Actions/CustomerPrices.action';

const CustomerPrices = ({ variantSystemId, mode, fetchPrices=false }) => {
  const dispatch = useDispatch();
  const { priceList } = useSelector(
    (state) => state.customerPrices
  );
  const data = Object.values(priceList).find(
    (x) => x.variantSystemId === variantSystemId
  );

  useEffect(() => {
    if(fetchPrices){
      dispatch(getPrices());
    }
  }, [fetchPrices])

  return data?.formattedPrice ? (
    <>
      <span
        className={`${
          mode === 'list'
            ? 'product-list-item__net-price'
            : 'product-card__net-price'
        }`}
      >
        {data.formattedPrice}
      </span>
      <span
        className={`${
          mode === 'list'
            ? 'product-list-item__compare-price'
            : 'product-card__compare-price'
        }`}
      >
        {data.priceComparison}
      </span>
    </>
  ) : (
    <span className="price-loader">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </span>
  );
};

export default CustomerPrices;
